import request from '@/utils/request'; // 上传接口

export function upload(data) {
  return request({
    url: '/upload/image',
    method: 'post',
    data: data
  });
}